<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    this.int()
  },
  methods: {
    async int() {
      let res = await this.$http
        .getBaseApp('api/v3/WeplusData/getUserWeplusIdentify', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data.is_weplus || res.data.is_old_weplus) {
            this.$http.appBack()
            let url =
              'pages/image-page/index?url=' +
              encodeURIComponent(
                'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3f8618f18428bfe843b5b97970067ae5.png'
              )
            this.$betterwe.jumpMiniProgram({ path: url })
          } else {
            this.$http.appBack()
            this.$betterwe.vipHomePage()
          }
        } else {
          this.$toast('接口异常错误')
        }
      }
    }
  }
}
</script>
